export enum SUCCESS_MESSAGES {
  SubmitOVFSuccess = "Adjusted OVF Submitted.",
}
